export const CALENDAR_GRID_WEEK_GROUP_MORE_PREFIX = '+'
